import React from 'react';
import PropTypes from 'prop-types';
import { FormatOptions } from '../../../../common/table/CellTypeConstants';
import { getCurrencyList } from '../../../utils/currencyUtils';
import Icon from '../../../components/icons/Icon';
import { getCurrencyDisplayOptions } from '../../../../common/table/utils/tableCellFormattingUtils';
import SelectInput from '../../../components/select/SelectInput';

import { useTranslator } from '../../../components/i18n/useTranslator';

const CurrencyFormatOptions = (props) => {
    const { sharedFormattingValues, updateCellTypeFormat, locale } = props;
    const { currency, currencyDisplay } = sharedFormattingValues;
    const translate = useTranslator('popup', 'table.format');

    return (
        <div className="CurrencyFormatOptions celltype-format-section">
            <div className="celltype-format-title">
                {translate('currency')}
            </div>
            <div className="celltype-format-inputs">
                <div className="dropdown-container celltype-format-input">
                    <SelectInput
                        value={currency || ''}
                        onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY]: e.target.value })}
                        className="dropdown"
                    >
                        <option value="" disabled>
                            {translate('selectCurrency')}
                        </option>
                        {getCurrencyList(locale).map(({ id, name }) => (
                            <option key={id} value={id}>
                                {name}
                            </option>
                        ))}
                    </SelectInput>
                    <div className="arrow-icon-container">
                        <Icon name="dropdown-arrow" />
                    </div>
                </div>
                {currency && (
                    <div className="dropdown-container celltype-format-input">
                        <SelectInput
                            value={currencyDisplay}
                            onChange={(e) => updateCellTypeFormat({ [FormatOptions.CURRENCY_DISPLAY]: e.target.value })}
                            className="dropdown"
                        >
                            {getCurrencyDisplayOptions(currency, locale).map((displayOption, i) => (
                                <option key={i} value={displayOption.option}>
                                    {displayOption.value}
                                </option>
                            ))}
                        </SelectInput>
                        <div className="arrow-icon-container">
                            <Icon name="dropdown-arrow" />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

CurrencyFormatOptions.propTypes = {
    sharedFormattingValues: PropTypes.object,
    updateCellTypeFormat: PropTypes.func,
    locale: PropTypes.string,
};

export default CurrencyFormatOptions;
